<button class="modal-close" (click)="close()"></button>
<h4 class="modal-title">
  Upload CSV data
</h4>
<div class="modal-content">
  <div *ngIf="!errors; else errorTemplate">
    <p
      i18n="Import CSV|Message to explain how to import data @@importCsvAction"
    >
      Select the 'Chooce CSV file' button below and specify a file to upload
      from your computer.
    </p>
    <p
      i18n="Import CSV|Message to explain csv template @@importCsvActionTemplate"
    >
      Please note your CSV file must be formatted according to our
      <a [href]="csvTemplate" download="csv-template.csv">CSV template</a> in
      order to be uploaded correctly.
    </p>
    <div class="u-border-all import-table-wrapper">
      <ls-table [cols]="data.csvData[0].length">
        <thead>
          <tr>
            <th *ngFor="let head of data.csvData[0]">{{ head }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td *ngFor="let cell of data.csvData[1]">{{ cell }}</td>
          </tr>
        </tbody>
      </ls-table>
    </div>
    <div>
      <label class="o-button o-button--default import-select-file">
        <input type="file" (change)="selectFile($event)" accept="text/csv" />
        <span i18n="Import CSV|Button to choose csv file @@importCsvButton"
          >Choose CSV file</span
        >
      </label>
    </div>
  </div>
  <ng-template #errorTemplate>
    <div class="import-errors">
      <div class="import-errors-header">
        <i class="fa fa-exclamation-circle import-errors-icon"></i>
        <h5>The CSV file could not be uploaded. This is because:</h5>
      </div>
      <ul class="import-error-list">
        <li *ngFor="let error of errors">{{ error | lsTranslate }}</li>
      </ul>
    </div>
    <h5 i18n="Import CSV|Header when import went wrong @@importCsvErrorHeader">
      What's next?
    </h5>
    <p
      i18n="Import CSV|Message when import went wrong  @@importCsvErrorMessage"
    >
      Resolve the above possible errors on your CSV file and try again.
    </p>
    <p
      *ngIf="data.helpArticle"
      i18n="Import CSV|Link when import went wrong @@importCsvErrorLink"
    >
      For more information on uploading a CSV file,
      <a [href]="data.helpArticle" target="_blank">click here</a>.
    </p>
  </ng-template>
</div>
<div class="modal-footer">
  <button
    type="button"
    name="button"
    class="o-button o-button--default"
    (click)="close()"
    i18n="Button|Cancel Button @@buttonCancel"
  >
    Cancel
  </button>
</div>
<div
  i18n="Import CSV|CSV import error when the file is too large @@importCsvErrorFileTooLarge"
  id="The file is too large"
  ls-dynamic-translation
>
  The file is too large
</div>
<div
  i18n="Import CSV|CSV import error when the file contains too many lines @@importCsvErrorFileTooManyLines"
  id="The file contains too many lines (max. 10,000 lines per file)"
  ls-dynamic-translation
>
  The file contains too many lines (max. 10,000 lines per file)
</div>
<div
  i18n="Import CSV|CSV import error when the file has the incorrect format @@importCsvErrorIncorrectFormat"
  id="The file is not in a CSV format"
  ls-dynamic-translation
>
  The file is not in a CSV format
</div>
